module.exports = __webpack_public_path__ + "static/media/next.a25ea368.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/profile/tabs/HomeTab/resources/next.svg
// module id = 3480
// module chunks = 0